<template lang="pug">
div
  template(v-if="currentDsTab == 'dailystatement'")
    .card.mb-0
      .card-header
        .row.w-100
          .form-group.col-12
            DateRangePicker(:value="dateRange" @update="getData")
          .form-group.col-12.mb-1
            SubmitButton(
              icon="fa fa-search"
              :loading="loading"
              :text="$t('ui.search')"
              type="button"
              @click="getStatement(true)"
              variant="primary"
              size="sm"
            ).mr-2
            jsonToExcel(v-if="statementList.length > 0" mode="DailyStatement" tbl="dsList" :date="dateRange")
            dailyStatementExport(v-if="statementList.length > 0" :tbl="statementList" :totalTbl="grandTotalList" tblId="dsList")
      .card-body
        .row
          .col-10.mb-1
            b-pagination.float-left(
              size="sm"
              hide-ellipsis
              :total-rows="totalRow"
              :per-page="getPageSize"
              v-model="currentPage"
              @input="changedPage($event)")
          .col-2.mb-1
            b-input-group(:prepend="$t('ui.page_size')" size="sm")
              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
          .col-12(style="max-height: 70vh; overflow: hidden;")
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover#dsList
                thead.thead-light
                  tr
                    th.text-center(width="3%")
                      span #
                    th.sortable(width="10%" @click="sortOrder('working_date')")
                      span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
                      .float-right
                        i(:class="changeSortKey('working_date')")
                    th.text-right(width="9%")
                      span(:title="$t('ui.opening_balance')") {{ $t('ui.opening_balance') }}
                    th.text-right(width="7%")
                      span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                    th.text-right(width="9%")
                      span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                    th.text-right(width="7%")
                      span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                    th.text-right(width="8%")
                      span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
                    th.text-right(width="9%")
                      span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                    th.text-right(width="7%")
                      span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                    th.text-right(width="9%")
                      span(:title="$t('ui.adjustment_amount')") {{ $t("ui.adjustment_amount") }}
                    th.text-right(width="7%")
                      span(:title="$t('ui.referee_count')") {{ $t("ui.referee_count") }}
                    th.text-right(width="7%")
                      span(:title="$t('ui.voucher')") {{ $t("ui.voucher") }}
                    th.text-right(width="8%")
                      span(:title="$t('ui.closing_balance')") {{ $t("ui.closing_balance") }}
                tbody.clusterize-content
                  tr(v-if="statementList.length == 0")
                    td(colspan="13").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in statementList")
                    td.text-center
                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                    td
                      span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(item.opening_balance)" :title="$n(item.opening_balance, 'currency')") {{ $n(item.opening_balance, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                    td.text-right
                      //- span.font-weight-bold(v-if="item.winlose == 0" :class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                      //- span.font-weight-bold(v-if="item.winlose != 0")
                      //-   b-link(href="javascript:void(0);" @click="redirectToWL(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                      //- TEMP HIDE
                      //- span.font-weight-bold(v-if="item.winlose != 0 && showActionButton('platformwinlose')")
                      //-   b-link(href="javascript:void(0);" @click="redirectToWL(item)" :class="$helpers.fontClassName(item.winlose, true)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                      //- span.font-weight-bold(v-else :class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                      span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                    td.text-right
                      //- TEMP HIDE
                      span.font-weight-bold(v-if="item.deposit_amount == 0" :class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                      span.font-weight-bold(v-if="item.deposit_amount != 0")
                        b-link.font-weight-bold(href="javascript:void(0);" @click="redirectToTicketWalletTrans(item, 'DEPOSIT')" :class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                      //- span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                    td.text-right
                      //- TEMP HIDE
                      span.font-weight-bold(v-if="item.withdrawal_amount == 0" :class="$helpers.fontClassName(getWithdrawalAmount(item.withdrawal_amount))" :title="$n(getWithdrawalAmount(item.withdrawal_amount), 'currency')") {{ $n(getWithdrawalAmount(item.withdrawal_amount), 'currency') }}
                      span.font-weight-bold(v-if="item.withdrawal_amount != 0")
                        b-link.font-weight-bold(href="javascript:void(0);" @click="redirectToTicketWalletTrans(item, 'WITHDRAWAL')" :class="$helpers.fontClassName(getWithdrawalAmount(item.withdrawal_amount))" :title="$n(getWithdrawalAmount(item.withdrawal_amount), 'currency')") {{ $n(getWithdrawalAmount(item.withdrawal_amount), 'currency') }}
                      //- span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount)" :title="$n(item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount, 'currency') }}
                    td.text-right
                      //- TEMP HIDE
                      //- span.font-weight-bold(v-if="item.bonus_amount == 0" :class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                      //- span.font-weight-bold(v-if="item.bonus_amount != 0")
                      //-   b-link(href="javascript:void(0);" @click="redirectToBonus(item)" :class="$helpers.fontClassName(item.bonus_amount, true)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                      span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                    td.text-right
                      //- TEMP HIDE
                      //- span.font-weight-bold
                      //-   b-link(href="javascript:void(0);" @click="redirectToAdjustment(item)" :class="[item.adjustment_amount < 0 ? 'text-danger' : 'text-info']" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                      span.font-weight-bold(:class="$helpers.fontClassName(item.adjustment_amount)" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:title="$n(item.referee_count, 'integer')") {{ $n(item.referee_count, 'integer') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(item.voucher_gen)" :title="$n(item.voucher_gen, 'currency')") {{ $n(item.voucher_gen, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(item.closing_balance)" :title="$n(item.closing_balance, 'currency')") {{ $n(item.closing_balance, 'currency') }}
                  tr(v-if="showTotal")
                    td.text-right(colspan="3")
                      span {{ $t("ui.sub_total") }}
                      br
                      span {{ $t("ui.grand_total") }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalDepositAmount)" :title="$n(subTotalDepositAmount, 'currency')") {{ $n(subTotalDepositAmount, 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmount)" :title="$n(grandTotalDepositAmount, 'currency')") {{ $n(grandTotalDepositAmount, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(getWithdrawalAmount(subTotalWithdrawalAmount))" :title="$n(getWithdrawalAmount(subTotalWithdrawalAmount), 'currency')") {{ $n(getWithdrawalAmount(subTotalWithdrawalAmount), 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(getWithdrawalAmount(grandTotalWithdrawalAmount))" :title="$n(getWithdrawalAmount(grandTotalWithdrawalAmount), 'currency')") {{ $n(getWithdrawalAmount(grandTotalWithdrawalAmount), 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalBonusAmount)" :title="$n(subTotalBonusAmount, 'currency')") {{ $n(subTotalBonusAmount, 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmount)" :title="$n(grandTotalBonusAmount, 'currency')") {{ $n(grandTotalBonusAmount, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalAdjustmentAmount)" :title="$n(subTotalAdjustmentAmount, 'currency')") {{ $n(subTotalAdjustmentAmount, 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAdjustmentAmount)" :title="$n(grandTotalAdjustmentAmount, 'currency')") {{ $n(grandTotalAdjustmentAmount, 'currency') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalRefereeCount)" :title="$n(subTotalRefereeCount, 'integer')") {{ $n(subTotalRefereeCount, 'integer') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRefereeCount)" :title="$n(grandTotalRefereeCount, 'integer')") {{ $n(grandTotalRefereeCount, 'integer') }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(subTotalVoucherGen)" :title="$n(subTotalVoucherGen, 'currency')") {{ $n(subTotalVoucherGen, 'currency') }}
                      br
                      span.font-weight-bold(:class="$helpers.fontClassName(grandTotalVoucherGen)" :title="$n(grandTotalVoucherGen, 'currency')") {{ $n(grandTotalVoucherGen, 'currency') }}
                    td

  template(v-else-if="currentDsTab == 'ticketWalletTrans'")
    ticketWalletTransList(@backClick="backClick")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
// import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import ticketWalletTransList from "@/components/reportTab/ticketWalletTransList.vue";
import dailyStatementExport from "@/components/report/dailyStatementExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    ticketWalletTransList,
    dailyStatementExport
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    grandTotalList: [],
    statementList: [],
    currentPage: 1,
    totalRow: 0,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalDepositAmount: 0,
    grandTotalDepositAmount: 0,
    subTotalWithdrawalAmount: 0,
    grandTotalWithdrawalAmount: 0,
    subTotalBonusAmount: 0,
    grandTotalBonusAmount: 0,
    subTotalAdjustmentAmount: 0,
    grandTotalAdjustmentAmount: 0,
    subTotalRefereeCount: 0,
    grandTotalRefereeCount: 0,
    subTotalVoucherGen: 0,
    grandTotalVoucherGen: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    // locale: {
    //   format: "YYYY-MM-DD",
    //   useCurrent: true
    // },
    sortKey: "working_date",
    sortType: "desc",
    currentDsTab: 'dailystatement'
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberReport;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
  },
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null
    };

    this.$store.dispatch("user/setDailyStatementParam", json);
  },
  methods: {
    getWithdrawalAmount(amount) {
      const value = parseFloat(amount) || 0;
      return value > 0 ? value * -1 : value;
    },
    backClick() {
      this.currentDsTab = 'dailystatement'
    },
    refresh() {
      if (this.$store.getters.dailyStatement.start_date && this.$store.getters.dailyStatement.end_date) {
        this.dateRange.startDate = this.$store.getters.dailyStatement.start_date;
        this.dateRange.endDate = this.$store.getters.dailyStatement.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getStatement(true);
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    clearDateRange() {
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getStatement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getStatement(true);
    },
    setDailyStatementParam() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.$store.dispatch("user/setDailyStatementParam", json);
    },
    redirectToWL: function(item) {
      var json = {
        // operator_id: this.searchID.trim(),
        // member_id: this.memberID.trim(),
        start_date: item.working_date,
        end_date: item.working_date
      };
      this.$store.dispatch("user/setWinLoseParam", json);
      this.$router.push("/report/platformWinLose");
    },
    redirectToAdjustment: function(item) {
      var json = {
        member_id: this.memberID,
        start_date: item.working_date,
        end_date: item.working_date
      };

      this.$store.dispatch("user/setAdjustmentListParam", json);
      this.$router.push("/report/adjustmentList");
    },
    redirectToBonus: function(item) {
      var json = {
        member_id: this.memberID,
        start_date: item.working_date,
        end_date: item.working_date
      };

      this.$store.dispatch("user/setBonusListParam", json);
      this.$router.push("/report/bonusList");
    },
    redirectToTicketWalletTrans: function(item, type) {
      var json = {
        operator_id: this.operatorID,
        member_id: this.memberID,
        working_date: item.working_date,
        request_type: type
      };

      this.$store.dispatch("user/setTicketWalletTransListParam", json);
      this.currentDsTab = 'ticketWalletTrans'
      // this.$router.push("/report/ticketWalletTransList");
    },
    getStatement: function(isSearch) {
      if (this.checkDateRange()) {
        this.setDailyStatementParam();

        let url = config.dailyStatementUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID.trim(),
          member_id: this.memberID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.statement.length > 0) {
                    this.showTotal = true;
                    response.data.ds.statement.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalDepositAmount = parseFloat(this.subTotalDepositAmount) + parseFloat(value["deposit_amount"]);
                      this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"]);
                      this.subTotalBonusAmount = parseFloat(this.subTotalBonusAmount) + parseFloat(value["bonus_amount"]);
                      this.subTotalAdjustmentAmount = parseFloat(this.subTotalAdjustmentAmount) + parseFloat(value["adjustment_amount"]);
                      this.subTotalRefereeCount = parseInt(this.subTotalRefereeCount) + parseInt(value["referee_count"]);
                      this.subTotalVoucherGen = parseInt(this.subTotalVoucherGen) + parseInt(value["voucher_gen"]);
                    });


                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalDepositAmount = response.data.ds.grand_total[0]["deposit_amount"];
                      this.grandTotalWithdrawalAmount = response.data.ds.grand_total[0]["withdrawal_amount"];
                      this.grandTotalBonusAmount = response.data.ds.grand_total[0]["bonus_amount"];
                      this.grandTotalAdjustmentAmount = response.data.ds.grand_total[0]["adjustment_amount"];
                      this.grandTotalRefereeCount = response.data.ds.grand_total[0]["referee_count"];
                      this.grandTotalVoucherGen = response.data.ds.grand_total[0]["voucher_gen"];
                    }

                    this.grandTotalList = response.data.ds.grand_total
                    this.statementList = response.data.ds.statement;
                    this.totalRow = response.data.ds.statement.length > 0 ? this.statementList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.statementList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.statementList = []
      this.totalRow = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalDepositAmount = 0
      this.grandTotalDepositAmount = 0
      this.subTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalAmount = 0
      this.subTotalBonusAmount = 0
      this.grandTotalBonusAmount = 0
      this.subTotalAdjustmentAmount = 0
      this.grandTotalAdjustmentAmount = 0
      this.subTotalRefereeCount = 0
      this.grandTotalRefereeCount = 0
      this.subTotalVoucherGen = 0
      this.grandTotalVoucherGen = 0
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'dailystatement') return
      this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
      this.currentPage = 1;
      this.getStatement(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>